import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import { format, parseISO } from 'date-fns';
import { ISO_DATE_TIME_FORMAT, OG_META_TAG_NAME_ARTICLE_AUTHOR, OG_META_TAG_NAME_ARTICLE_PUBLISHED, SCHEMA_ORG_CONTEXT, SCHEMA_ORG_TYPE_BLOG, SCHEMA_ORG_TYPE_IMAGE, SCHEMA_ORG_TYPE_PERSON } from './constants';
import { BusinessProviderPropType } from './types/business';
import { getBusinessSchemaType } from './utils/business';
import { markdownToPlainText } from './utils/markdown';
import { Helmet } from '../../../modules/foundation/components/HelmetProvider';
import { formatAuthorName, getAuthorAttributes } from '../../../services/blog';
var defaultProps = {
  heroImage: null,
  summary: '',
  author: {}
};
export default function BlogPostSchema(_ref) {
  var businessName = _ref.businessName,
    businessCategories = _ref.businessCategories,
    businessLogo = _ref.businessLogo,
    datePublished = _ref.datePublished,
    title = _ref.title,
    heroImage = _ref.heroImage,
    author = _ref.author,
    content = _ref.content,
    summary = _ref.summary;
  var data = {
    '@context': SCHEMA_ORG_CONTEXT,
    '@type': SCHEMA_ORG_TYPE_BLOG,
    headline: title,
    description: markdownToPlainText(summary),
    articleBody: markdownToPlainText(content),
    publisher: {
      '@type': getBusinessSchemaType(businessCategories),
      name: businessName
    }
  };
  var metaTags = [];
  var publishedDateIso = null;
  if (datePublished) {
    publishedDateIso = format(parseISO(datePublished), ISO_DATE_TIME_FORMAT);
    data = _objectSpread(_objectSpread({}, data), {}, {
      datePublished: publishedDateIso
    });
    metaTags.push({
      name: OG_META_TAG_NAME_ARTICLE_PUBLISHED,
      content: publishedDateIso
    });
  }
  var _getAuthorAttributes = getAuthorAttributes(author),
    firstName = _getAuthorAttributes.firstName,
    lastName = _getAuthorAttributes.lastName;
  if (firstName || lastName) {
    data = _objectSpread(_objectSpread({}, data), {}, {
      author: {
        '@type': SCHEMA_ORG_TYPE_PERSON,
        givenName: firstName,
        familyName: lastName
      }
    });
    metaTags.push({
      name: OG_META_TAG_NAME_ARTICLE_AUTHOR,
      content: formatAuthorName(firstName, lastName)
    });
  }
  if (heroImage && typeof heroImage === 'string') {
    data = _objectSpread(_objectSpread({}, data), {}, {
      image: {
        '@type': SCHEMA_ORG_TYPE_IMAGE,
        url: heroImage
      }
    });
  }
  if (businessLogo) {
    data.publisher.logo = {
      '@type': SCHEMA_ORG_TYPE_IMAGE,
      url: businessLogo
    };
  }
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(data)), metaTags.map(function (_ref2) {
    var name = _ref2.name,
      metaContent = _ref2.content;
    return /*#__PURE__*/React.createElement("meta", {
      key: name,
      name: name,
      content: metaContent
    });
  }));
}
BlogPostSchema.defaultProps = defaultProps;